export const integrationsEn = {
  title: "Integrations",
  granola: {
    title: "Granola",
    description:
      "API mode: your Granola notes reach the CRM on their own every 2 minutes (summary only, never the transcript).",
    status: {
      none: "Not connected",
      connected: "Connected",
      invalid: "Invalid key",
      trial_ended: "Trial ended",
      error: "Error",
    },
    connected_on: "Connected on %{at}. The key is never shown again.",
    last_sync: "Last sync: %{at}",
    first_sync: "First sync within 5 minutes (notes from the last 30 days).",
    key_label: "Granola API key",
    key_help:
      "In the Granola desktop app: Settings → Connectors → API keys → “Create new key”. Business or Enterprise plan required.",
    save_key: "Save key",
    disconnect: "Disconnect Granola",
    sync_now: "Sync now",
    synced_toast: "Granola sync finished.",
    confirm_disconnect_title: "Disconnect Granola?",
    confirm_disconnect_body:
      "The key is deleted. Notes already synced stay in the CRM.",
    connected_toast: "Granola is connected.",
    disconnected_toast: "Granola is disconnected.",
    invalid_help:
      "Granola key expired or revoked — back to manual paste. Paste a new key to resume syncing.",
    trial_ended_help:
      "Your Granola plan no longer includes API access (trial ended?) — back to manual paste. Reconnect a key once your plan allows it.",
    error_help:
      "The Granola sync failed. It retries on its own; manual paste is still available.",
    manual_always:
      "Manual paste (“Add Granola notes” on a lead, a deal or in Meetings) is always available.",
    errors: {
      granola_key_format:
        "This is not a Granola API key (it starts with grn_).",
      granola_key_invalid: "Invalid key: Granola refused it.",
      granola_plan_required:
        "Your Granola plan has no API access (Business or Enterprise required).",
      granola_rate_limited: "Granola is busy. Try again in a minute.",
      granola_sync_too_soon: "A sync was just started. Try again in a minute.",
      granola_sync_failed: "The Granola sync failed. Try again later.",
      granola_not_connected: "Granola is not connected.",
      granola_too_many_attempts:
        "Too many key attempts. Try again in 10 minutes.",
      granola_unavailable: "Granola is not responding. Try again later.",
      unauthorized: "Session expired. Sign in to the CRM again.",
      network: "Network error. Try again.",
      unknown: "Connecting to Granola failed.",
    },
  },
  granola_partners: {
    title: "Partners and consultants",
    hint: "One entry per line: a domain (mnp.ca), an address (name@gmail.com) or a phone number. A Granola meeting with only colleagues or partners goes straight to « Internes ».",
    label: "List",
    save: "Save",
    saved: "List saved.",
    save_failed: "The list could not be saved.",
    error_line: "Line %{line} (“%{text}”): %{reason}",
    reasons: {
      invalid: "not a domain, an address or a phone number",
      free_mail_domain: "free email domain — enter the full address",
      too_many: "200 entries at most",
    },
  },
  api_keys: {
    title: "API keys",
    help: "For the Gavion platform and Gala. A key is shown only once.",
    create: "Create a key",
    name: "Name",
    scopes: "Permissions",
    prefix: "Key",
    last_used: "Last used",
    created: "Created",
    never: "Never",
    revoke: "Revoke",
    revoked: "Revoked",
    active: "Active",
    confirm_revoke:
      "Revoke the key “%{name}”? Calls using it will fail immediately.",
    empty: "No API keys.",
    toast_revoked: "Key revoked.",
    base_url: "API base URL",
    scope: {
      contacts_read: "Read contacts",
      contacts_write: "Create and update contacts",
      activities_write: "Log activities",
      deals_write: "Create deals",
      webhooks_manage: "Manage webhooks",
      jobs_read: "Read published job postings (website)",
      jobs_write: "Send job applications (website)",
    },
  },
  secret_once: {
    title: "Copy this value now",
    help: "It will never be shown again.",
    copy: "Copy",
    copied: "Copied.",
    copy_failed: "Copy failed: select the value and copy it by hand.",
    done: "I copied the value",
  },
  webhooks: {
    title: "Outbound webhooks",
    help: "The CRM sends signed events (HMAC SHA-256) to these addresses.",
    create: "Add an endpoint",
    url: "URL (https)",
    events: "Events",
    enabled: "Active",
    disabled: "Disabled",
    enable: "Enable",
    disable: "Disable",
    failures: "Consecutive failures",
    last_success: "Last success",
    delete: "Delete",
    confirm_delete: "Delete this endpoint?",
    empty: "No webhooks.",
    url_invalid:
      "The URL must start with https:// and point to a public server.",
    url_errors: {
      https_required: "The URL must start with https://.",
      credentials_not_allowed:
        "The URL must not contain credentials (user:password).",
      port_not_allowed: "The port must be the default https port (443).",
      host_not_allowed: "This host name is not allowed.",
      private_address: "The URL cannot point to a private address.",
    },
    event: {
      lead_created: "Lead created",
      lead_updated: "Lead updated",
      call_logged: "Call logged",
      demo_booked: "Demo booked",
      deal_stage_changed: "Deal stage changed",
      deal_won: "Deal won",
      deal_lost: "Deal lost",
      contact_unsubscribed: "Unsubscribed",
      contact_do_not_call: "Do not call",
    },
  },
  inbound: {
    title: "Gala inbound webhook",
    help: "Leads captured by Gala arrive here once the owner selects the “Generic webhook” CRM in the Gavion platform settings and pastes this URL and secret there.",
    url: "URL to configure",
    status_on: "Active",
    status_off: "Inactive",
    enable: "Enable",
    disable: "Disable",
    rotate: "Generate a new secret",
    confirm_rotate:
      "Generate a new secret? The old one stops working immediately.",
    secret_set: "Secret set on %{date}",
    no_secret: "No secret",
    last_received: "Last received",
    never: "Never",
    copy_url: "Copy URL",
    url_copied: "URL copied.",
    signature_title: "Request signature",
    signature_help:
      "Header X-Gavion-Signature: sha256=<hex>, an HMAC-SHA256 computed with this secret over the exact raw body bytes, sent unchanged. The signed occurred_at must be at most 24 h old and at most 5 min in the future, otherwise 401 stale_request. The CRM de-duplicates on the SHA-256 of the raw body: an identical resend returns replayed: true.",
    runbook: "Full procedure: docs/runbooks/gala-inbound.md",
  },
  errors: {
    forbidden: "Access denied.",
    admin_only: "Admins only.",
    invalid_name: "Enter a name (100 characters max).",
    invalid_scopes: "Choose at least one permission.",
    invalid_url:
      "The URL must start with https:// and point to a public server.",
    invalid_events: "Choose at least one event.",
    secret_missing: "Generate a secret first.",
    not_found: "Not found.",
    unknown: "Something went wrong. Try again.",
  },
};
